import React from "react";
import classes from "./StartTest.module.css";
import ClearIcon from "@material-ui/icons/Clear";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import { readAssessment } from "../../../../store/actions/assessment.action";
import {
  clearQuestion,
  getQuestion,
} from "../../../../store/actions/questions.action";
import {
  getAssessmentResponce,
  startAssessment,
  resumeAssessment,
} from "../../../../store/actions/questionAnswer.action";
import {
  getusername,
  getKneuraId,
  getClassInfo,
} from "../../../../utils/authentication-access";
import moment from "moment";
import { withTranslation } from "react-i18next";
import RollBackPopup from "../../RollBack/RollBackPopup";

class StartTest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showClose: true,
    };
  }

  async componentDidMount() {
    let assessmentId = localStorage.getItem("_assessmentId");
    let userId = localStorage.getItem("kneuraId");
    if (sessionStorage.getItem("assessmentinfo")) {
      const assessmentInfo = JSON.parse(
        sessionStorage.getItem("assessmentinfo")
      );
      this.setState({ showClose: assessmentInfo.showClose });
    }

    await this.props.clearQuestion();
    await this.props.readAssessment(assessmentId);
    await this.props.getAssessmentResponce(assessmentId, userId);
    this.checkAssessmentStatus();
  }

  // componentWillReceiveProps(nextProps) {
  //   if (this.props.assesmentresponseid !== nextProps.assesmentresponseid) {
  //     this.props.history.push("/test");
  //   }

  // }
  checkAssessmentStatus = () => {
    if (this.props.assesmentresponse.status == "Completed") {
      this.props.history.replace("/test-submitted");
    } if (this.props.assesmentresponse.status == "PendingEvaluation") {
      this.props.history.replace("/assessments/evaluation-pending");
    }
  };

  gotoassessment = async () => {
    this.props.history.goBack();
  };

  startTest = () => {
    let assessmentId = localStorage.getItem("_assessmentId");
    this.props.clearQuestion();
    this.props.startAssessment(assessmentId, getKneuraId());
    this.props.history.push("/test");
  };

  resumeTest = () => {
    let assessmentId = localStorage.getItem("_assessmentId");
    this.props.clearQuestion();
    this.props.resumeAssessment(assessmentId, getKneuraId());
    this.props.history.push("/test");
  };

  render() {
    const { t } = this.props;
    return (
      <>
        <RollBackPopup />
        <div className={classes.starttestgrid}>
          <div className={classes.starttestheader}>
            <ClearIcon
              className={classes.pointercursor}
              style={{ color: "#5b697d", pointer: "cursor" }}
              onClick={this.gotoassessment}
            />
          </div>
          <div className={classes.starttestcontent}>
            <div className={classes.assessmenttitle}>
              {this.props.assessmentData.name
                ? this.props.assessmentData.name
                : "Assessment"}
            </div>
            <div className={classes.subtitlegrid}>
              <div className={classes.subgrid}>
                {" "}
                <div className={classes.assessmentsubtitle}>
                  {t("Total Score")} :
                </div>{" "}
                <div className={classes.assessmentdiscription}>
                  {this.props.assessmentData.totalScore
                    ? this.props.assessmentData.totalScore
                    : " No Points"}
                </div>
              </div>
              <div className={classes.subgrid}>
                {" "}
                <div className={classes.assessmentsubtitle}>
                  {t("Due on")} :
                </div>{" "}
                <div className={classes.assessmentdiscription}>
                  {this.props.assessmentData.setting
                    ? this.props.assessmentData.setting.dueOn
                      ? moment(this.props.assessmentData.setting.dueOn).format(
                        "MMM Do, h:mm a"
                      )
                      : " No Due"
                    : " No Due"}
                </div>
              </div>
              <div className={classes.subgrid}>
                {" "}
                <div className={classes.assessmentsubtitle}>
                  {t("Time Limit")} :
                </div>{" "}
                <div className={classes.assessmentdiscription}>
                  {this.props.assessmentData.setting
                    ? (this.props.assessmentData.setting.timeLimit && this.props.assessmentData.setting.timeLimit !== -1)
                      ? this.props.assessmentData.setting.timeLimit + " m"
                      : t("No Time Limit")
                    : t("No Time Limit")}
                </div>
              </div>
            </div>

            <ExpansionPanel>
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className={classes.assessmentsubtitle}>
                  {t("Description")}
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <div className={classes.assessmentdiscription}>
                  {this.props.assessmentData.setting
                    ? this.props.assessmentData.setting.description
                      ? this.props.assessmentData.setting.description
                      : t("No Description")
                    : t("No Description")}
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel>
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <div className={classes.assessmentsubtitle}>
                  {t("Scoring guide")} ({t("Rubric")})
                </div>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <div className={classes.assessmentdiscription}>
                  {this.props.assessmentData.setting
                    ? this.props.assessmentData.setting.rubric
                      ? this.props.assessmentData.setting.rubric
                      : t("No Infromation")
                    : t("No Infromation")}
                </div>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </div>
          <div className={classes.starttestfooter}>
            <div className={classes.assessmentsubtitle}>
              {this.props.assessmentData.questions
                ? this.props.assessmentData.questions.length + " Questions"
                : t("No Questions")}
            </div>
            {this.props.assessmentData.questions ? (
              this.props.assessmentData.questions.length ? (
                this.props.assesmentresponse.status == "InProgress" ? (
                  <Button
                    disableElevation
                    variant="contained"
                    color="primary"
                    onClick={this.resumeTest}
                  >
                    {" "}
                    {t("Resume test")}
                  </Button>
                ) : (
                    <Button
                      disableElevation
                      variant="contained"
                      color="primary"
                      onClick={this.startTest}
                    >
                      {" "}
                      {t("Start test")}
                    </Button>
                  )
              ) : (
                  <div className={classes.assessmentsubtitle}>
                    {" "}
                    {t("Add questions")}
                  </div>
                )
            ) : (
                <div className={classes.assessmentsubtitle}>
                  {" "}
                  {t("Add questions")}
                </div>
              )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    assessmentData: state.assessmentsReducer.assessmentdata,
    assesmentresponseid: state.questionanswer.assessmentresponse.id,
    assesmentresponse: state.questionanswer.assessmentresponse,
  };
};

export default connect(mapStateToProps, {
  readAssessment,
  clearQuestion,
  getQuestion,
  getAssessmentResponce,
  startAssessment,
  resumeAssessment,
})(withTranslation()(StartTest));
